import { Component, EventEmitter, Input, input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatStepperNext, MatStepperPrevious } from '@angular/material/stepper';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-pine-stepper-footer',
  templateUrl: './pine-stepper-footer.component.html',
  standalone: true,
  imports: [MatButton, MatStepperNext, MatStepperPrevious],
  styleUrl: './pine-stepper-footer.component.css'
})
export class PineStepperFooterComponent {
  @Input() position: 'start' | 'end' | 'summary';
  @Input() fg: FormGroup;
  @Output() parentEventTransmitter = new EventEmitter();
  @Output() exportParentEventTransmitter = new EventEmitter();

  runReportClicked() {
    this.parentEventTransmitter.emit(true);
  }

  backFromSummaryClicked() {
    this.parentEventTransmitter.emit(true);
  }

  exportPdf() {
    this.exportParentEventTransmitter.emit(true);
  }
}
